import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { Container, Reveal, ImageReveal } from "@/components/Reveal";
import { INDUSTRIES } from "@/data/content";

export default function Industries() {
  return (
    <>
      <SEO
        title="Industries"
        description="How commercial energy procurement applies across manufacturing, real estate, hospitality, healthcare, logistics, and data centers."
        path="/industries"
      />
      <PageHero
        overline="Industries"
        titleLines={["Built for how", "your sector runs."]}
        subtitle="Every industry consumes energy differently. We bring sector-specific pattern recognition to your procurement and market strategy."
        crumbs={[{ label: "Industries", path: "/industries" }]}
      />

      <section className="bg-white py-24 md:py-32">
        <Container>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.slug} delay={(i % 3) * 0.08}>
                <Link
                  to={`/industries/${ind.slug}`}
                  data-testid={`industries-card-${ind.slug}`}
                  className="group flex h-full flex-col overflow-hidden border border-line transition-colors hover:border-electric"
                >
                  <ImageReveal
                    src={ind.image}
                    alt={ind.name}
                    className="aspect-[16/10]"
                    imgClassName="transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="flex flex-1 flex-col p-7">
                    <h3 className="font-heading text-xl font-medium text-navy">
                      {ind.name}
                    </h3>
                    <p className="mt-3 flex-1 leading-relaxed text-slatey">
                      {ind.summary}
                    </p>
                    <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-electric">
                      Explore sector
                      <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      <CTABand />
    </>
  );
}
